import { guardEmptyString, guardUnspecified } from '@portal/utils/util-guards';
import { componentFactory } from 'vue-tsx-support';

import { injectStylesMixin } from '../../../mixins/inject-styles';
import { JtnUiImage } from '../../jtn-ui-image';

import styles from './jtn-ui-widget-item.styles.scss?module';

type ImageSources = {
  srcset: string;
  type?: string;
  media?: string;
}[];

type Image = {
  sources?: ImageSources;
  url: string;
};

export default componentFactory.mixin(injectStylesMixin(styles)).create({
  name: 'JtnUiWidgetItem',
  props: {
    header: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    image: {
      type: Object as () => Image
    }
  },
  computed: {
    hasImage(): boolean {
      return guardUnspecified(this.image?.url) && guardEmptyString(this.image?.url);
    }
  },
  render() {
    const attributes = {
      attrs: this.$attrs,
      on: this.$listeners
    };

    return (
      <a class={styles.widgetItem} href={this.url} {...attributes}>
        <div class={styles.infoWrap}>
          <h4 class={styles.itemTitle} domPropsInnerHTML={this.header} />
          <span class={styles.itemSubtitle} domPropsInnerHTML={this.subtitle} />
        </div>

        {this.hasImage && (
          <JtnUiImage
            class={styles.itemImage}
            src={this.image?.url}
            sources={this.image.sources ?? []}
            alt={this.header}
            width={104}
            height={70}
          />
        )}
      </a>
    );
  }
});
